

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>







<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>

<br><br>


<!--  -->
<div class="row" data-aos="zoom-in" data-aos-delay="300"    >
  <div class="col-md-6 text-center">
    <img style="width:70%;height: 90%;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #76b891;" src="assets/thirdpartydue.jpg">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">Redefining Third party Due Diligence, Setting the New Standards</span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;Comprehensive due diligence solution for risk-free business partnerships supported by our pan-India presence, multilingual workforce, and experienced analytical professionals.</h5>
    </div>

    
</div>
<br><br>





<!--  -->

<div class="row" data-aos="fade-up" data-aos-delay="300"  >
    <div class="col">
        <h1 style="color: #6ab187;text-align: center;">Unravel Your Due Diligence Challenges</h1>
        <br>
        <p style="text-align: center;">Transform your business due diligence processes with our tech-enabled solutions</p>

           <br><br>
<div  class="row p-2 ">

    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"   class="col-md-4">
        <br>
        <img style="width: 70px;height: 65px;background-color: #eff8ff;" src="assets/cloud.jpg">
       <br><br><br>
        <h5>Accurate, reliable & up-to-date data at your fingertips</h5>
        <p style="align-items: center;">Experience the power of our exceptional due diligence service, providing up-to-date and precise financial, and legal data. Stay ahead with accurate and reliable business insights & reports</p>
    </div>
  
    <div style="background-color: #c9d9e6;"  data-aos="fade-up" data-aos-delay="300"   class="col-md-4">
          <br>
          <img style="width: 70px;height: 60px;" src="assets/compliancemanage.png">
         <br><br><br>
          <h5>Continuous monitoring of existing business partners</h5>
          <p style="align-items: center;">Strengthen your business integrity with ongoing due diligence and constant vigilance over third-party businesses for enhanced compliance and risk management</p>
      </div>
     
       
    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"   class="col-md-4">
        <br>
        <img style="width: 80px;height: 70px;" src="assets/absentrisk.png">
       <br><br><br>
        <h5>Unparalleled efficiency & Industry-leading turnaround time</h5>
        <p style="align-items: center;">Get your hands on an all-inclusive due diligence report delivered with unparalleled efficiency, boasting the industry’s fastest turnaround time (TAT)</p>
    </div>


  </div>
    </div>
</div> 



<!--  -->

<div class="row" data-aos="zoom-in" data-aos-delay="300" >
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">Holistic Due Diligence for your comprehensive needs</h3>
     <p style="text-align: center;">Achieve unprecedented levels of efficiency and effectiveness in your due diligence process.</p>
    </div>
</div>



<!--  -->
<div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
  <div class="col-md-6">
      <br>
      <img style="width: 39px;height: 39px" src="assets/riskicon.jpg">
      <span style="color: #6ab187;">Operational Risk Assessment</span><br>
      <h3 style="text-align: start;color: #6ab187;">Risk-Free Business Operation </h3>
      <p >In order to assess operational risks, our 1000+ Operations team thoroughly evaluates your business operations, including the supply chain and demand side factors. We conduct litigation checks from 260 million litigation records to identify potential legal risks and also gather valuable stakeholder feedback from Businesses’ suppliers, customers, and bankers.</p>
  </div>

  <div class="col-md-6  text-center">
      <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/riskfree.jpg">
  </div>
  </div>


 <!--  -->
 
 <div class="row p-2"  data-aos="fade-up" data-aos-delay="300"  >
  
     <div class="col-md-6 text-center   ">
         <img style="width: 80%;height: 90%;margin-left: 20px;" src="assets/riskmanageimage.png">
     </div>
 
     <div class="col">
         <img style="width: 42px;height: 45px;" src="assets/riskmanagment.png">
         <span style="color: #6ab187;height: 20%;">Management Risk assessment</span>
         <h3 style="text-align: start;color: #6ab187;">Thorough Due-Dilgence of Management</h3>
         <p >Our comprehensive management risk assessment includes evaluating directors’ qualifications and profiles, reviewing the organization’s structure for effective management, and assessing key management systems and controls. We also conduct checks for past litigation involving management to identify potential risks</p>
     </div>
 </div>



<!--  -->
<div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
  <div class="col-md-6">
      <br>
      <img style="width: 39px;height: 39px" src="assets/finance.png">
      <span style="color: #6ab187;">Financial Risk Assessment</span><br>
      <h3 style="text-align: start;color: #6ab187;">Comprehensive Financial performance Analysis</h3>
      <p >We analyze financial statements of the past three years, identify key trends, and conduct ratio analysis for financial stability and growth potential. We evaluate bank exposure and relationships, review auditors’ reports and comments, and assess contingent liabilities for a comprehensive financial assessment</p>
  </div>

  <div class="col-md-6 text-center">
      <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/riskfree.jpg">
  </div>
  </div>



 <!-- advantages -->
  
 <div class="row" data-aos="zoom-in" data-aos-delay="300"    >
  <div class="col">
          <h2 style="text-align: center;font-size: 550;color: #6ab187;">Facheck Due Diligence Solution Parameters</h2>
          <p style="text-align: center;">Helping you choose the right Business partners</p>
  </div>
  </div>
  <br><br><br>



    <div  class="row p-2">
  
        <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
            <br>
            <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/signout.png">
           <br><br><br>
            <h5>Differentiator Risk Scoring</h5>
            <p style="align-items: center;">For Secure User Authentication and Compliance</p>
        </div>
      
        <div style="background-color: #c9d9e6;"  data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
              <br>
              <img style="width: 70px;height: 80px;" src="assets/profitability.png">
             <br><br>
              <h5>Profitability Assessment</h5>
              <p style="align-items: center;">To Streamline communication</p>
          </div>
         
          <div  style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
         
            <br>
            <img style="width: 60px;height: 60px;" src="assets/investment.png">
           <br><br><br>
            <h5>Investment Due Diligence</h5>
            <p style="align-items: center;">Real-time tracking of case status<p>
        </div>
    
    
        <div style="background-color: #eff8ff;"  data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
            <br>
            <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/score.png">
           <br><br><br>
            <h5>Balanced Scorecard</h5>
            <p style="align-items: center;">For expanding the reach and improving conversions</p>
        </div>
        
        <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"   class="col-md-3">
          <br>
          <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/sign.png">
         <br><br><br>
          <h5>E- Signature</h5>
          <p style="align-items: center;">To create a list of all the vendors for future use</p>
      </div>
    
      <div style="background-color: #c9d9e6;"  data-aos="fade-up" data-aos-delay="300"   class="col-md-3">
            <br>
            <img style="width: 70px;height: 80px;" src="assets/endtoendonboard.png">
           <br><br>
            <h5>End-to-end Onboarding</h5>
            <p style="align-items: center;">For quicker verification and turnaround time (TAT)</p>
        </div>
       
        <div  style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-3">
       
          <br>
          <img style="width: 60px;height: 60px;" src="assets/audits.png">
         <br><br><br>
          <h5>Process Audits</h5>
          <p style="align-items: center;">Two-way communication across multiple channels<p>
      </div>
  
  
      <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"   class="col-md-3">
          <br>
          <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/financemonitor.png">
         <br><br><br>
          <h5>Continuous Monitoring</h5>
          <p style="align-items: center;">To keep track of case status and notify stakeholders</p>
      </div>
  

      </div>
      
      
     



     
    

        
<!--  -->

<div class="row"  data-aos="zoom-in" data-aos-delay="300" >
  <div class="col">
    <br><br><br>
      <h3 style="text-align: center;color: #6ab187;">20+  Business Due Diligence Checks</h3><br>
      <p style="text-align: center;">Built for Success at Every Step of the Onboarding Journey</p>
  </div>

</div>
<br><br>



<!--  -->
<div  class="row p-2 text-center" data-aos="fade-up" data-aos-delay="300"   >
  <div class="col-md-3 mt-2">
      <div  class="card"  style="height: 180px;" >
          <div class="card-body">
              <img style="width: 34%;height:30%" src="assets/udyogaadhaar.jpg">
              <br><br>
            <h5 class="card-title">Udyog Aadhaar</h5>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2">
    <div class="card"  style="height: 180px;" >
        <div class="card-body">
            <img style="width: 34%;height:30%" src="assets/bankaccount.png">
            <br><br>
          <h5 class="card-title">Bank Account</h5>
        </div>            
      </div>
</div>

<div class="col-md-3 mt-2">
  <div class="card"  style="height: 180px;" >
      <div  class="card-body">

          <img style="width: 30%;height:30%" src="assets/directorcheck.jpg">
          <br><br>
        <h5 class="card-title">Defaulting Directors Check</h5>
      </div>            
    </div>
</div>

<div class="col-md-3 mt-2">
<div class="card"  style="height: 180px;" >
    <div class="card-body">
        <img style="width: 34%;height:30%"  src="assets/tincheck.png">
        <br><br>
      <h5 class="card-title">TIN Check</h5>

    </div>            
  </div>
</div>
<div class="col-md-3 mt-2">
  <div  class="card"  style="height: 180px;" >
      <div class="card-body">
          <img style="width: 34%;height:30%" src="assets/businesswork.png">
          <br><br>
        <h5 class="card-title">Business address</h5>
      </div>            
    </div>
</div>

<div class="col-md-3 mt-2">
<div class="card"  style="height: 180px;" >
    <div class="card-body">
        <img style="width: 34%;height:30%" src="assets/GSTIN.jpg">
        <br><br>
      <h5 class="card-title">GSTIN verify</h5>
    </div>            
  </div>
</div>

<div class="col-md-3 mt-2">
<div class="card"  style="height: 180px;" >
  <div  class="card-body">

      <img style="width: 30%;height:30%" src="assets/panchecks.png">
      <br><br>
    <h5 class="card-title">PAN Card</h5>
  </div>            
</div>
</div>

<div class="col-md-3 mt-2">
<div class="card"  style="height: 180px;" >
<div class="card-body">
    <img style="width: 34%;height:30%"  src="assets/dinverify.jpg">
    <br><br>
  <h5 class="card-title">DIN verify</h5>
</div>            
</div>
</div>

</div>
<br><br>
<br>


<!--  -->




<br><br>





